import { getDefaultMailboxFolderTreeData } from '../store/getDefaultMailboxFolderTreeData';
import { setMailboxFolderTreeDataMutator } from '../mutators/setMailboxFolderTreeData';
import { getMailboxFolderTreeData } from '../selectors/getMailboxFolderTreeDataTable';
import type { MailboxInfo } from 'owa-client-types';

export function initializeFolderTreeData(mailboxInfo: MailboxInfo): void {
    if (!getMailboxFolderTreeData(mailboxInfo)) {
        setMailboxFolderTreeDataMutator(mailboxInfo, getDefaultMailboxFolderTreeData(mailboxInfo));
    }
}
